/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc
 */

/**
 * One user's slice of {@link UnappliedRequestedChanges#getChangesByUser()}.
 */

export const getUserIdsOnHubByRoleIdAndPendingStatusRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'getUserIdsOnHubByRoleIdAndPendingStatus',
  auth: 'app',
  fingerprint: 'sPR9EE1FPIgBU2e0akw6AVcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const filterOutInvisibleUsersRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'filterOutInvisibleUsers',
  auth: 'app',
  fingerprint: 'z54Q9us7gedyyGwM-v7ZvVcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUsersByIdsRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'getUsersByIds',
  auth: 'app',
  fingerprint: '2zwwN0u_84e7bEiN-TP8SlcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserPermissionsRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'setUserPermissions',
  auth: 'app',
  fingerprint: 'rRqFJl3z6U8cP0Fcwuzm6FcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserPermissionsAndSeatsRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'setUserPermissionsAndSeats',
  auth: 'app',
  fingerprint: 'LJfIKn4X6sLM3mKaBBaHTFcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const addUserBulkRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'addUserBulk',
  auth: 'app',
  fingerprint: '17GGuAH-iuARMdcRdTM49VcYGAbSNxd0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};